
import unionBlack from '~/assets/images/main/icons/union-black.svg'
export default {
  name: 'Checkbox',
  props: ['label', 'fontSize'],
  data() {
    return {
      isChecked: false,
      unionBlack,
    };
  },
methods: {

},
  mounted() {
    this.isChecked = false
  }

};
